import { EditOutlined } from '@ant-design/icons';
import { hideLoadingScreen, showLoadingScreen } from "@app/store/reducers/loading";
import { Col, FloatButton, Input, Row, Tabs } from "antd";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { trangThaiDonNghiPhep } from "../../constants";
import { Links } from "../../helpers/Links";
import { dateCommon } from "../../helpers/common";
import { CongViec } from "../../models/congviec/CongViec";
import { layCTCongViec } from "../../services/congviec";
const { TextArea } = Input;

const XemCongViec = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const params = new URLSearchParams(window.location.search)
    let id = params.get('id') || '0';
    const user = useSelector((state: any) => state.auth.currentUser);
    const [data, setData] = useState<CongViec>(new CongViec);
    const [reload, setReload] = useState(false);

    const layCongViec = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            if (id > 0) {
                var data = await layCTCongViec(id);
                setData(data);
            }
        }
        catch (error: any) {
            toast.error(error);
        }
        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        if (parseInt(id) > 0) {
            layCongViec(parseInt(id));
        }
    }, []);

    useEffect(() => {
        if (reload) {
            if (parseInt(id) > 0) {
                layCongViec(parseInt(id));
            }
            setReload(false);
        }
    }, [reload]);

    return (
        <section style={{ paddingBottom: "60px" }}>
            <ContentHeader title="Chi tiết công việc" />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs defaultActiveKey="1" items={[
                            {
                                key: '1',
                                label: <span>Thông tin </span>,
                                children:
                                    <Row>
                                        <Col span="24" className="card card-body">
                                            <Row gutter={24}>
                                                <Col span={8}>
                                                    <div>
                                                        <div>Nhân viên thực hiện</div>
                                                        <label>{(data?.nhanViens || []).map(x => x.tenNhanVien).join(', ')}</label>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div>Thời gian giao</div>
                                                    <label>{dateCommon.formatDate(data?.thoiGianGiao)}</label>
                                                </Col>
                                                <Col span={8}>
                                                    <div>Thời gian yêu cầu hoàn thành</div>
                                                    <label>{dateCommon.formatDate(data?.thoiGianYeuCauHoanThanh)}</label>
                                                </Col>
                                            </Row>
                                            <Row gutter={24}>
                                                <Col span={24}>
                                                    <div>Nội dung</div>
                                                    <label>{data?.noiDung}</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                            },
                        ]}>
                        </Tabs>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <div className="card-outline">

                        <Row className="mt-1 mb-1">
                            <Col span="24">
                                {
                                    user.idNhanVien == data?.idNVKhoiTao &&
                                    <FloatButton.Group
                                        trigger="hover"
                                        type="primary"
                                        style={{ right: 50, bottom: 80 }}
                                    >
                                        <>
                                            {
                                                data?.isGiaoViec
                                                    ? <FloatButton
                                                        tooltip="Chỉnh sửa giao việc"
                                                        className="hrm-btn-warning"
                                                        icon={<EditOutlined rev="" />}
                                                        onClick={() => {
                                                            navigate(Links.CongViec.GiaoViec + "?id=" + id);
                                                        }}
                                                    />
                                                    : <FloatButton
                                                        tooltip="Chỉnh sửa công việc"
                                                        className="hrm-btn-warning"
                                                        icon={<EditOutlined rev="" />}
                                                        onClick={() => {
                                                            navigate(Links.CongViec.Them + "?id=" + id);
                                                        }}
                                                    />
                                            }
                                        </>
                                    </FloatButton.Group>
                                }
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </section>
    )
}

export default XemCongViec;